import { render } from "./Gameboard_SidePanel_BS.vue?vue&type=template&id=5c278e5c"
import script from "./Gameboard_SidePanel_BS.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_BS.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_BS.vue?vue&type=style&index=0&id=5c278e5c&lang=scss"
script.render = render

export default script